import { FC } from "react"

interface MenuBurgerProps {
  onClick: () => void
}
const MenuBurger: FC<MenuBurgerProps> = ({ onClick }) => (
  <div className="menu-btn-wrapper" onClick={onClick}>
    <span className="menu-btn">
      <span className="menu-btn-burger" />
    </span>
  </div>
)

export default MenuBurger
